import { getEpoch, getTodayWithTime } from "../DateFormatter";

const isGradingProfileWindowOpen = (windows, profileTimePeriod) => {
    if (!windows || !Array.isArray(windows)) return false;

    const profileGradingWindow = windows.find(
        (window) => window.action === "GRADING_PROFILE" && Number(window.differentiator) === Number(profileTimePeriod)
    );

    if (!profileGradingWindow) return false;

    const now = getEpoch(getTodayWithTime());
    const start = getEpoch(profileGradingWindow.startDate);
    const end = getEpoch(profileGradingWindow.endDate);

    return start <= now && now < end;
};

export default isGradingProfileWindowOpen;
